import { Pipe, PipeTransform } from '@angular/core';
import { DependantFormTemplate } from '../interfaces';

@Pipe({
  name: 'acornDisplayDependantName',
  standalone: true,
})
export class DisplayDependantNamePipe implements PipeTransform {
  transform(
    value: { [key: string]: DependantFormTemplate },
    applicationUserId: string,
    questionId: string
  ): string {
    return value[applicationUserId].questions[questionId].dependantName;
  }
}
